import { buildUrl, handleRequest } from '@common/services/requestHelper';
import { RequestType } from '@common/services/types';
import { Id } from '@common/types';

const basePath = process.env.REACT_APP_API_PATH;

const buildQuery = (search: string | null, limit?: number) => {
  const query = [];

  search && query.push(`search=${search}`);
  limit && query.push(`limit=${limit}`);

  return query.join('&');
};

// Active Ingredients
const fetchPublishedActiveIngredients = async (queryString: string) => {
  const url = buildUrl('/substance/search', basePath, queryString);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchProposedActiveIngredients = async () => {
  const url = buildUrl('/substance/suggestions', basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const updateActiveIngredient = async (substanceId: Id, data: unknown) => {
  const url = buildUrl(`/substance/${substanceId}`, basePath);

  return handleRequest({ url, requestType: RequestType.PUT, data });
};

const removeActiveIngredient = async (substanceId: Id) => {
  const url = buildUrl(`/substance/${substanceId}`, basePath);

  return handleRequest({ url, requestType: RequestType.DELETE });
};

const approveProposedActiveIngredient = async (substanceId: Id, dataSet: unknown) => {
  const url = buildUrl(`/substance/suggestion/${substanceId}/approve`, basePath);

  return handleRequest({ url, requestType: RequestType.PATCH, data: dataSet });
};

const replaceProposedActiveIngredient = async (substanceId: Id, dataSet: unknown) => {
  const url = buildUrl(`/substance/suggestion/${substanceId}/replace`, basePath);

  return handleRequest({ url, requestType: RequestType.POST, data: dataSet });
};

// product-form
const fetchLookupProductForms = async (search: string | null, limit?: number) => {
  let url = buildUrl(`/product-form`, basePath, buildQuery(search, limit));

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchPublishedProductForms = async (queryString: string) => {
  const url = buildUrl('/product-form/search', basePath, queryString);

  return handleRequest({ url, requestType: RequestType.GET });
};

const fetchProposedProductForms = async () => {
  const url = buildUrl('/product-form/suggestions', basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

const updateProductForm = async (productFormId: Id, data: unknown) => {
  const url = buildUrl(`/product-form/${productFormId}`, basePath);

  return handleRequest({ url, requestType: RequestType.PUT, data });
};

const removeProductForm = async (productFormId: Id) => {
  const url = buildUrl(`/product-form/${productFormId}`, basePath);

  return handleRequest({ url, requestType: RequestType.DELETE });
};

const approveProposedProductForm = async (productFormId: Id, dataSet: unknown) => {
  const url = buildUrl(`/product-form/suggestion/${productFormId}/approve`, basePath);

  return handleRequest({ url, requestType: RequestType.PATCH, data: dataSet });
};

const replaceProposedProductForm = async (productFormId: Id, dataSet: unknown) => {
  const url = buildUrl(`/product-form/suggestion/${productFormId}/replace`, basePath);

  return handleRequest({ url, requestType: RequestType.POST, data: dataSet });
};

export {
  fetchPublishedActiveIngredients,
  fetchProposedActiveIngredients,
  updateActiveIngredient,
  approveProposedActiveIngredient,
  replaceProposedActiveIngredient,
  fetchLookupProductForms,
  fetchPublishedProductForms,
  fetchProposedProductForms,
  removeActiveIngredient,
  updateProductForm,
  removeProductForm,
  approveProposedProductForm,
  replaceProposedProductForm
};